import LetterBook from 'components/modules/LetterBook';
import PracticeBook from 'components/modules/PracticeBook';
import TeachersGuide from 'components/modules/TeachersGuide';
import LetterResources from 'components/modules/Resources/components/LetterResources';
import ResourcesProvider from '@monorepo/shared/src/providers/ResourcesProvider';

const TabComponentList = () => [
  {
    Component: ({ singleLetter }) => (
      <LetterBook
        letter={singleLetter}
        backRoute={`/letter-teaching/${singleLetter}/letter-book`}
      />
    ),
  },
  {
    Component: ({ singleLetter }) => <PracticeBook letter={singleLetter} />,
  },
  {
    Component: ({ singleLetter }) => <TeachersGuide letter={singleLetter} />,
  },
  {
    Component: ({ singleLetter }) => (
      <ResourcesProvider>
        <LetterResources letter={singleLetter} />
      </ResourcesProvider>
    ),
  },
];

export default TabComponentList;
